import { render, staticRenderFns } from "./UserTrendViewSwitch.vue?vue&type=template&id=511f9f08&scoped=true"
import script from "./UserTrendViewSwitch.vue?vue&type=script&lang=ts"
export * from "./UserTrendViewSwitch.vue?vue&type=script&lang=ts"
import style0 from "./UserTrendViewSwitch.vue?vue&type=style&index=0&id=511f9f08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511f9f08",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/user-trend/user-trend-view-switch.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fuser-trend%2FUserTrendViewSwitch.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports